import type { FacetConfiguration } from "../facet/type.ts";

export type FilterTitleMode =
  | "onlyTitle"
  | "full"
  | "onlyPopularValuesAndTitle"
  | "onlyValues"
  | "popularValuesExclusion";

export type FilterOptions = {
  filterTitleMode?: FilterTitleMode;
};
export type FilterMode = "default" | "sheetFirstLevel" | "sheetSecondLevel";

/*                                                                                                                           */
/*                                                       */
export type FilterConfiguration = FilterOptions & {
  filterTitleMode?: "onlyTitle";
  facetConfig: FacetConfiguration;
};

export type FilterModeConfigurations = {
  default: FilterConfiguration;
  sheetFirstLevel?: FilterConfiguration;
  sheetSecondLevel?: FilterConfiguration;
};

export type ConfigurableFilterOptions = FilterOptions & {
  filterConfig: FilterModeConfigurations;
};

export function switchFilterMode(config: FilterModeConfigurations, mode: FilterMode): FilterConfiguration {
  if (!config[mode]) {
    return config.default;
  }
  return config[mode];
}
